export default __webpack_public_path__ + "static/media/UNFI.d8246065.png";